import { ArrowLinkCell } from 'components/link/ArrowLink';
import styled from 'styled-components';

export const FilesLinkCell = styled(ArrowLinkCell)`
    display: flex;
    flex-direction: row;
    align-items: center;
    height: calc(100% - 2rem);
`;
